/* =========================================================================
   Cross-Sell A/B Quiz-Widget -- <cross-sell-ab-quiz>
   Wird von sections/cross-sell-ab.liquid auf der Produktseite gerendert.
   Zwei Darstellungsvarianten (data-variant="routine"|"sales"), gleiche
   Empfehlungslogik (CSAB_MATRIX/CSAB_NEEDS). Produktkatalog (Preise, Bilder,
   Varianten-IDs) kommt aus dem JSON-Script im Element, gepflegt ueber die
   Blocks der Section -- keine Fantasiepreise mehr wie im Prototyp.
   ========================================================================= */
if (!customElements.get("cross-sell-ab-quiz")) {
  const CSAB_ICONS = {
    sparkle:
      '<path d="M12 3.5l1.7 4.8 4.8 1.7-4.8 1.7L12 16.5l-1.7-4.8L5.5 10l4.8-1.7z"/><path d="M18.5 15.5l.7 1.8 1.8.7-1.8.7-.7 1.8-.7-1.8-1.8-.7 1.8-.7z"/>',
    sprout:
      '<path d="M12 21v-8"/><path d="M12 14c0-3.9 3.1-7 7-7 0 3.9-3.1 7-7 7z"/><path d="M12 17c0-3.3-2.7-6-6-6 0 3.3 2.7 6 6 6z"/>',
    flame:
      '<path d="M12 21.5c3.6 0 6.5-2.7 6.5-6 0-4.2-3.7-6.4-4.2-10.8-1.9 2.8-3.3 3.8-4.7 5.7-1.1 1.5-1.4 2.5-1.4 3.8 0 3.3 0 7.3 3.8 7.3z"/><path d="M12 21.5c1.6 0 2.9-1.2 2.9-2.8 0-1.9-1.6-2.7-1.9-4.7-.9 1.4-2.4 2.4-2.4 4.3 0 1.8.8 3.2 1.4 3.2z"/>',
    flower:
      '<circle cx="12" cy="12" r="2.2"/><circle cx="12" cy="6.8" r="2.7"/><circle cx="17.2" cy="12" r="2.7"/><circle cx="12" cy="17.2" r="2.7"/><circle cx="6.8" cy="12" r="2.7"/>',
    heart:
      '<path d="M12 20.2s-7.4-4.7-7.4-9.7A4.4 4.4 0 0 1 12 7.7a4.4 4.4 0 0 1 7.4 2.8c0 5-7.4 9.7-7.4 9.7z"/>',
    droplet:
      '<path d="M12 3.2s6.2 6.5 6.2 10.3a6.2 6.2 0 1 1-12.4 0C5.8 9.7 12 3.2 12 3.2z"/>',
    moon: '<path d="M20.2 14.6A8.6 8.6 0 0 1 9.4 3.8 8.6 8.6 0 1 0 20.2 14.6z"/>',
    sun: '<circle cx="12" cy="12" r="4"/><path d="M12 2.6v2.2M12 19.2v2.2M4.3 4.3l1.6 1.6M18.1 18.1l1.6 1.6M2.6 12h2.2M19.2 12h2.2M4.3 19.7l1.6-1.6M18.1 5.9l1.6-1.6"/>',
    cup: '<path d="M4.5 9h11.2v5.6a4.4 4.4 0 0 1-4.4 4.4H8.9a4.4 4.4 0 0 1-4.4-4.4z"/><path d="M15.7 10.4h1.9a2.4 2.4 0 0 1 0 4.8h-1.9"/><path d="M8.4 3.4v2.2M12 3.4v2.2"/>',
    capsule:
      '<rect x="2.8" y="8.6" width="18.4" height="6.8" rx="3.4" transform="rotate(-45 12 12)"/><path d="M9.6 9.6l4.8 4.8"/>',
    bottle:
      '<path d="M10 2.8h4v2.6l1.8 2.8v11a2 2 0 0 1-2 2h-3.6a2 2 0 0 1-2-2v-11L10 5.4z"/><path d="M8.2 12.4h7.6"/>',
    flora:
      '<circle cx="12" cy="12" r="8.4"/><circle cx="9.6" cy="10.2" r="1.1"/><circle cx="14.2" cy="9.6" r="1.1"/><circle cx="13" cy="14.4" r="1.1"/><circle cx="9.2" cy="14" r="1.1"/>',
    calendar:
      '<rect x="3.4" y="5.2" width="17.2" height="15.4" rx="3"/><path d="M3.4 10h17.2M8.4 2.8v4M15.6 2.8v4"/>',
    omega:
      '<path d="M7.4 19.6h2.8C7.9 18 6.6 15.7 6.6 13a5.4 5.4 0 0 1 10.8 0c0 2.7-1.3 5-3.6 6.6h2.8"/>',
    bone: '<path d="M9.6 14.4l4.8-4.8"/><circle cx="6.6" cy="15.4" r="2.6"/><circle cx="8.6" cy="17.4" r="2.6"/><circle cx="17.4" cy="8.6" r="2.6"/><circle cx="15.4" cy="6.6" r="2.6"/>',
    run: '<circle cx="14.6" cy="4.8" r="1.9"/><path d="M8 21l2.6-5.2-2.4-2.4 1.4-4.4 3.2-1.4 3 2.6 2.8 1"/><path d="M10.6 15.8l3.4 1.4 1.2 3.8M4.6 11.4l3-1.4"/>',
    check: '<path d="M4.6 12.6l4.8 4.8L19.4 7.2"/>',
    arrowRight: '<path d="M4.4 12h14M13.2 6.2l5.8 5.8-5.8 5.8"/>',
    arrowLeft: '<path d="M19.6 12h-14M10.8 6.2L5 12l5.8 5.8"/>',
    thumbUp:
      '<path d="M7.2 20.8H4.6a1.4 1.4 0 0 1-1.4-1.4v-6.6a1.4 1.4 0 0 1 1.4-1.4h2.6z"/><path d="M7.2 11.4l3.8-8a2.6 2.6 0 0 1 2.6 2.6v3.4h5a1.8 1.8 0 0 1 1.8 2.2l-1.6 7a1.8 1.8 0 0 1-1.8 1.4H7.2z"/>',
    thumbDown:
      '<path d="M16.8 3.2h2.6a1.4 1.4 0 0 1 1.4 1.4v6.6a1.4 1.4 0 0 1-1.4 1.4h-2.6z"/><path d="M16.8 12.6l-3.8 8a2.6 2.6 0 0 1-2.6-2.6v-3.4h-5a1.8 1.8 0 0 1-1.8-2.2l1.6-7A1.8 1.8 0 0 1 7 4h9.8z"/>',
    close: '<path d="M6.4 6.4l11.2 11.2M17.6 6.4L6.4 17.6"/>',
    refresh:
      '<path d="M20.4 12a8.4 8.4 0 1 1-2.5-6"/><path d="M18.6 2.8v3.8h-3.8"/>',
    star: '<path d="M12 3.4l2.6 5.4 5.9.8-4.3 4.2 1 5.9-5.2-2.8-5.2 2.8 1-5.9L3.5 9.6l5.9-.8z"/>',
    truck:
      '<path d="M2.8 6.6h10.6v9.8H2.8z"/><path d="M13.4 9.8h3.8l3 3.2v3.4h-6.8z"/><circle cx="6.6" cy="18.4" r="1.9"/><circle cx="17" cy="18.4" r="1.9"/>',
    shield:
      '<path d="M12 2.8l7.4 3v5.4c0 4.4-3 8.2-7.4 9.6-4.4-1.4-7.4-5.2-7.4-9.6V5.8z"/><path d="M9 12l2.2 2.2L15.4 10"/>',
    tag: '<path d="M11.4 2.8H21v9.6l-9 9-9.6-9.6z"/><circle cx="16.6" cy="7.4" r="1.4"/>',
    cart: '<path d="M2.6 3.4h2.6l2.4 11.2h9.6l2.2-8H6.2"/><circle cx="9.4" cy="19.4" r="1.6"/><circle cx="16.8" cy="19.4" r="1.6"/>',
    users:
      '<circle cx="9" cy="8" r="3.2"/><path d="M3.4 19.6a5.6 5.6 0 0 1 11.2 0"/><path d="M16 5.2a3.2 3.2 0 0 1 0 5.8M17.4 19.6a5.6 5.6 0 0 0-2.2-4.4"/>',
    info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v5.4M12 7.8v.2"/>',
    alert: '<path d="M12 3.6l9 15.6H3z"/><path d="M12 9.6v4M12 16.4v.2"/>',
    bolt: '<path d="M13.4 2.6L4.6 13.8h6l-1 7.6 8.8-11.2h-6z"/>',
    clock: '<circle cx="12" cy="12" r="9"/><path d="M12 6.8V12l3.4 2"/>',
    leaf: '<path d="M4.6 19.4C3 15 4.4 8.6 9.4 6c3.4-1.8 7-1.4 10 .4.6 5.2-1.4 9.8-5.4 11.8-3.2 1.6-6.6 1.6-9.4 1.2z"/><path d="M4.6 19.4c2.4-3.8 5.6-6.8 9.6-8.8"/>',
  };

  function csabIcon(name, size, filled) {
    const s = size || 22;
    const f = filled ? "currentColor" : "none";
    return `<svg class="csab-ico" width="${s}" height="${s}" viewBox="0 0 24 24" fill="${f}" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${CSAB_ICONS[name] || CSAB_ICONS.leaf}</svg>`;
  }

  function csabStars(rating) {
    const pct = Math.max(0, Math.min(100, (rating / 5) * 100));
    const row = `<span class="row">${csabIcon("star", 14, true).repeat(5)}</span>`;
    return `<span class="csab-stars" role="img" aria-label="${String(rating).replace(".", ",")} von 5 Sternen">
        <span class="base">${row}</span>
        <span class="fill" style="width:${pct}%">${row}</span>
      </span>`;
  }

  // Fallback-Icon je Katalog-Schluessel, nur sichtbar solange ein Produkt kein Bild hat.
  const CSAB_ICON_BY_KEY = {
    TROPFEN: "droplet",
    TROPFEN_MILD: "leaf",
    KAPSELN: "capsule",
    TEE: "cup",
    SPRAY: "bottle",
    PROBIO_SHOT: "flora",
    DARM_KOMPLEX: "sprout",
    STOFFWECHSEL_SHOT: "flame",
    STOFFWECHSEL_KAPSELN: "flame",
    HORMON: "flower",
    CHOLESTERIN: "heart",
    ELEKTROLYTE: "bolt",
    VITAMIN_D3K2: "sun",
    OMEGA3: "omega",
    MAGNESIUM: "moon",
  };

  /* Bedarfe -> Folgefrage -> gewichtete Kandidaten. 'formats' verknuepft
     einen Kandidaten mit den Antworten der Folgefrage. Diese Empfehlungs-
     logik ist Fachlogik der Produktentwicklung, nicht editierbarer Content
     -- deshalb hier hinterlegt statt als Theme-Einstellung. */
  const CSAB_NEEDS = [
    {
      key: "verdauung",
      label: "Verdauung & Darmgesundheit",
      sub: "Ein gutes Bauchgefühl, jeden Tag",
      icon: "sprout",
      followUp: {
        question: "Wie soll das in Deinen Alltag passen?",
        options: [
          {
            key: "flora",
            label: "Darmflora aufbauen",
            sub: "Ein Shot am Morgen, schnell getrunken",
            icon: "flora",
          },
          {
            key: "kur",
            label: "Als feste Kur",
            sub: "Ein Ritual über mehrere Wochen",
            icon: "calendar",
          },
          {
            key: "egal",
            label: "Such Du das Beste aus",
            sub: "Ich habe keine Präferenz",
            icon: "sparkle",
          },
        ],
      },
      candidates: [
        {
          target: "PROBIO_SHOT",
          formats: ["flora", "egal"],
          reason:
            "Lebende Kulturen ergänzen Deine Bitterstoffe genau dort, wo sie allein nicht hinkommen – beim Aufbau der Darmflora. Der Shot ist schnell getrunken und damit leicht durchzuhalten.",
        },
        {
          target: "DARM_KOMPLEX",
          formats: ["kur", "egal"],
          reason:
            "Drei Wirkstoffkomplexe in einer täglichen Portion. Wenn du Dir eine feste Kur vornimmst, ist das die Variante, die am wenigsten Aufwand macht – und genau darum bleibt man dran.",
        },
      ],
    },
    {
      key: "gewicht",
      label: "Wohlfühlgewicht & Stoffwechsel",
      sub: "Dranbleiben statt Kurzprogramm",
      icon: "flame",
      followUp: {
        question: "Wie soll das in Deinen Alltag passen?",
        options: [
          {
            key: "shot",
            label: "Als Shot",
            sub: "Flüssig, in Sekunden erledigt",
            icon: "bottle",
          },
          {
            key: "kapseln",
            label: "Als Kapseln",
            sub: "Geschmacksneutral, überall dabei",
            icon: "capsule",
          },
          {
            key: "egal",
            label: "Such Du das Beste aus",
            sub: "Ich habe keine Präferenz",
            icon: "sparkle",
          },
        ],
      },
      candidates: [
        {
          target: "STOFFWECHSEL_SHOT",
          formats: ["shot", "egal"],
          reason:
            "Der Shot ist in Sekunden getrunken – die Variante mit der niedrigsten Hürde, wenn Du morgens wenig Zeit hast.",
        },
        {
          target: "STOFFWECHSEL_KAPSELN",
          formats: ["kapseln", "egal"],
          reason:
            "Geschmacksneutral und immer dabei: die Kapseln funktionieren auch an den Tagen, an denen die Routine sonst kippt.",
        },
      ],
    },
    {
      key: "frauen",
      label: "Frauengesundheit",
      sub: "Zyklus, Balance und Wohlbefinden",
      icon: "flower",
      followUp: {
        question: "Was steht für Dich im Vordergrund?",
        options: [
          {
            key: "balance",
            label: "Hormonelle Balance",
            sub: "Über den ganzen Zyklus hinweg",
            icon: "flower",
          },
          {
            key: "entspannung",
            label: "Krämpfe & Entspannung",
            sub: "Muskeln, Nerven und Schlaf",
            icon: "moon",
          },
        ],
      },
      candidates: [
        {
          target: "HORMON",
          formats: ["balance"],
          reason:
            "Pflanzlich und auf den Zyklus abgestimmt. Wirkt nicht von heute auf morgen, sondern über Wochen – deshalb lohnt sich hier die feste Routine besonders.",
        },
        {
          target: "MAGNESIUM",
          formats: ["entspannung"],
          reason:
            "Magnesium trägt zu einer normalen Muskelfunktion bei. Die unaufgeregte Basis, die sich problemlos jeden Abend einbauen lässt.",
        },
      ],
    },
    {
      key: "herz",
      label: "Herz & Gefäße",
      sub: "Werte, die sich über Zeit bewegen",
      icon: "heart",
      followUp: {
        question: "Was möchtest Du gezielt unterstützen?",
        options: [
          {
            key: "cholesterin",
            label: "Meine Cholesterinwerte",
            sub: "Gezielte Rezeptur dafür",
            icon: "heart",
          },
          {
            key: "allgemein",
            label: "Herz & Gehirn allgemein",
            sub: "Die breite Basis",
            icon: "omega",
          },
        ],
      },
      candidates: [
        {
          target: "CHOLESTERIN",
          formats: ["cholesterin"],
          reason:
            "Unterstützt normale Cholesterinwerte im Rahmen einer ausgewogenen Ernährung. Werte verändern sich über Monate – regelmäßige Einnahme ist hier der entscheidende Teil.",
        },
        {
          target: "OMEGA3",
          formats: ["allgemein"],
          reason:
            "Omega-3 trägt zu einer normalen Herzfunktion bei und ist die Grundlage, auf der alles andere aufbauen kann.",
        },
      ],
    },
    {
      key: "hydration",
      label: "Hydration & Trinkroutine",
      sub: "Genug trinken, ohne dran zu denken",
      icon: "droplet",
      followUp: {
        question: "Wann brauchst Du das vor allem?",
        options: [
          {
            key: "sport",
            label: "Bei Sport & Hitze",
            sub: "Wenn Du viel schwitzt",
            icon: "run",
          },
          {
            key: "ritual",
            label: "Als tägliche Routine",
            sub: "Warm, zum Ausklang des Tages",
            icon: "cup",
          },
        ],
      },
      candidates: [
        {
          target: "ELEKTROLYTE",
          formats: ["sport"],
          reason:
            "Gleicht aus, was beim Schwitzen verloren geht. An aktiven Tagen der Baustein, der eine Routine erst rundmacht.",
        },
        {
          target: "TEE",
          formats: ["ritual"],
          reason:
            "Ein warmer Kräutertee ist der einfachste Anker für eine tägliche Gewohnheit – man muss sich nicht erinnern, man freut sich drauf.",
        },
      ],
    },
    {
      key: "schlaf",
      label: "Entspannung & Schlaf",
      sub: "Abends zur Ruhe kommen",
      icon: "moon",
      followUp: {
        question: "Woran möchtest Du ansetzen?",
        options: [
          {
            key: "mineral",
            label: "Muskeln & Nerven",
            sub: "Mineralstoffversorgung",
            icon: "bone",
          },
          {
            key: "ritual",
            label: "Mein Abendritual",
            sub: "Etwas Warmes vor dem Schlafen",
            icon: "cup",
          },
        ],
      },
      candidates: [
        {
          target: "MAGNESIUM",
          formats: ["mineral"],
          reason:
            "Magnesium trägt zu einer normalen Funktion von Muskeln und Nervensystem bei – und lässt sich mühelos jeden Abend einbauen.",
        },
        {
          target: "TEE",
          formats: ["ritual"],
          reason:
            "Ein fester Abendtee ist weniger ein Produkt als ein Signal an den Körper, dass der Tag vorbei ist. Genau daraus werden Gewohnheiten.",
        },
      ],
    },
    {
      key: "basis",
      label: "Tägliche Basisversorgung",
      sub: "Das Fundament unter allem",
      icon: "sun",
      followUp: {
        question: "Worauf legst Du dabei besonderen Wert?",
        options: [
          {
            key: "knochen",
            label: "Knochen & Immunsystem",
            sub: "Vitamin D3 + K2",
            icon: "bone",
          },
          {
            key: "herz",
            label: "Herz & Gehirn",
            sub: "Essenzielle Fettsäuren",
            icon: "omega",
          },
          {
            key: "muskeln",
            label: "Muskeln & Entspannung",
            sub: "Für Nerven und Schlaf",
            icon: "moon",
          },
        ],
      },
      candidates: [
        {
          target: "VITAMIN_D3K2",
          formats: ["knochen"],
          reason:
            "Unterstützt Knochen, Zähne und ein normales Immunsystem. Eine Basis, die über Monate wirkt – nicht über Tage.",
        },
        {
          target: "OMEGA3",
          formats: ["herz"],
          reason:
            "Essenzielle Fettsäuren für Herz und Gehirn: der Baustein, den die meisten Ernährungsweisen nicht zuverlässig abdecken.",
        },
        {
          target: "MAGNESIUM",
          formats: ["muskeln"],
          reason:
            "Muskeln, Nerven und normale psychische Funktion. Unspektakulär, aber genau deshalb leicht dauerhaft dabei zu behalten.",
        },
      ],
    },
  ];
  const CSAB_NEED_BY_KEY = Object.fromEntries(
    CSAB_NEEDS.map((n) => [n.key, n]),
  );
  const CSAB_LAST_RESORT = [
    "VITAMIN_D3K2",
    "OMEGA3",
    "MAGNESIUM",
    "CHOLESTERIN",
    "DARM_KOMPLEX",
  ];

  // 'E' empfohlen, 'B' bedingt/mit Hinweis, 'NE' nicht empfohlen, 'U' keine Angabe.
  const CSAB_MATRIX = {
    TROPFEN: {
      TROPFEN: "SELF",
      TROPFEN_MILD: "NE",
      KAPSELN: "NE",
      TEE: "U",
      SPRAY: "NE",
      PROBIO_SHOT: "U",
      DARM_KOMPLEX: "E",
      STOFFWECHSEL_SHOT: "U",
      STOFFWECHSEL_KAPSELN: "E",
      HORMON: "U",
      CHOLESTERIN: "E",
      ELEKTROLYTE: "U",
      VITAMIN_D3K2: "E",
      OMEGA3: "E",
      MAGNESIUM: "E",
    },
    TROPFEN_MILD: {
      TROPFEN: "NE",
      TROPFEN_MILD: "SELF",
      KAPSELN: "NE",
      TEE: "U",
      SPRAY: "NE",
      PROBIO_SHOT: "U",
      DARM_KOMPLEX: "E",
      STOFFWECHSEL_SHOT: "U",
      STOFFWECHSEL_KAPSELN: "E",
      HORMON: "B",
      CHOLESTERIN: "E",
      ELEKTROLYTE: "U",
      VITAMIN_D3K2: "E",
      OMEGA3: "E",
      MAGNESIUM: "E",
    },
    KAPSELN: {
      TROPFEN: "NE",
      TROPFEN_MILD: "NE",
      KAPSELN: "SELF",
      TEE: "U",
      SPRAY: "NE",
      PROBIO_SHOT: "U",
      DARM_KOMPLEX: "E",
      STOFFWECHSEL_SHOT: "U",
      STOFFWECHSEL_KAPSELN: "E",
      HORMON: "U",
      CHOLESTERIN: "E",
      ELEKTROLYTE: "U",
      VITAMIN_D3K2: "E",
      OMEGA3: "E",
      MAGNESIUM: "E",
    },
    TEE: {
      TROPFEN: "U",
      TROPFEN_MILD: "U",
      KAPSELN: "U",
      TEE: "SELF",
      SPRAY: "U",
      PROBIO_SHOT: "U",
      DARM_KOMPLEX: "E",
      STOFFWECHSEL_SHOT: "U",
      STOFFWECHSEL_KAPSELN: "E",
      HORMON: "E",
      CHOLESTERIN: "E",
      ELEKTROLYTE: "E",
      VITAMIN_D3K2: "E",
      OMEGA3: "E",
      MAGNESIUM: "E",
    },
    SPRAY: {
      TROPFEN: "NE",
      TROPFEN_MILD: "NE",
      KAPSELN: "NE",
      TEE: "U",
      SPRAY: "SELF",
      PROBIO_SHOT: "U",
      DARM_KOMPLEX: "E",
      STOFFWECHSEL_SHOT: "U",
      STOFFWECHSEL_KAPSELN: "E",
      HORMON: "U",
      CHOLESTERIN: "E",
      ELEKTROLYTE: "U",
      VITAMIN_D3K2: "E",
      OMEGA3: "E",
      MAGNESIUM: "E",
    },
    PROBIO_SHOT: {
      TROPFEN: "U",
      TROPFEN_MILD: "U",
      KAPSELN: "U",
      TEE: "U",
      SPRAY: "U",
      PROBIO_SHOT: "SELF",
      DARM_KOMPLEX: "E",
      STOFFWECHSEL_SHOT: "NE",
      STOFFWECHSEL_KAPSELN: "NE",
      HORMON: "E",
      CHOLESTERIN: "E",
      ELEKTROLYTE: "U",
      VITAMIN_D3K2: "E",
      OMEGA3: "E",
      MAGNESIUM: "E",
    },
    DARM_KOMPLEX: {
      TROPFEN: "E",
      TROPFEN_MILD: "E",
      KAPSELN: "E",
      TEE: "E",
      SPRAY: "E",
      PROBIO_SHOT: "E",
      DARM_KOMPLEX: "SELF",
      STOFFWECHSEL_SHOT: "NE",
      STOFFWECHSEL_KAPSELN: "NE",
      HORMON: "E",
      CHOLESTERIN: "E",
      ELEKTROLYTE: "U",
      VITAMIN_D3K2: "E",
      OMEGA3: "E",
      MAGNESIUM: "E",
    },
    STOFFWECHSEL_SHOT: {
      TROPFEN: "U",
      TROPFEN_MILD: "U",
      KAPSELN: "U",
      TEE: "U",
      SPRAY: "U",
      PROBIO_SHOT: "NE",
      DARM_KOMPLEX: "NE",
      STOFFWECHSEL_SHOT: "SELF",
      STOFFWECHSEL_KAPSELN: "NE",
      HORMON: "E",
      CHOLESTERIN: "E",
      ELEKTROLYTE: "U",
      VITAMIN_D3K2: "E",
      OMEGA3: "E",
      MAGNESIUM: "E",
    },
    STOFFWECHSEL_KAPSELN: {
      TROPFEN: "E",
      TROPFEN_MILD: "E",
      KAPSELN: "E",
      TEE: "E",
      SPRAY: "E",
      PROBIO_SHOT: "NE",
      DARM_KOMPLEX: "NE",
      STOFFWECHSEL_SHOT: "NE",
      STOFFWECHSEL_KAPSELN: "SELF",
      HORMON: "B",
      CHOLESTERIN: "E",
      ELEKTROLYTE: "U",
      VITAMIN_D3K2: "E",
      OMEGA3: "E",
      MAGNESIUM: "E",
    },
    HORMON: {
      TROPFEN: "U",
      TROPFEN_MILD: "B",
      KAPSELN: "U",
      TEE: "E",
      SPRAY: "U",
      PROBIO_SHOT: "E",
      DARM_KOMPLEX: "E",
      STOFFWECHSEL_SHOT: "E",
      STOFFWECHSEL_KAPSELN: "B",
      HORMON: "SELF",
      CHOLESTERIN: "NE",
      ELEKTROLYTE: "U",
      VITAMIN_D3K2: "E",
      OMEGA3: "E",
      MAGNESIUM: "B",
    },
    CHOLESTERIN: {
      TROPFEN: "E",
      TROPFEN_MILD: "E",
      KAPSELN: "E",
      TEE: "E",
      SPRAY: "E",
      PROBIO_SHOT: "E",
      DARM_KOMPLEX: "E",
      STOFFWECHSEL_SHOT: "E",
      STOFFWECHSEL_KAPSELN: "E",
      HORMON: "E",
      CHOLESTERIN: "SELF",
      ELEKTROLYTE: "U",
      VITAMIN_D3K2: "E",
      OMEGA3: "E",
      MAGNESIUM: "E",
    },
    ELEKTROLYTE: {
      TROPFEN: "U",
      TROPFEN_MILD: "U",
      KAPSELN: "U",
      TEE: "E",
      SPRAY: "U",
      PROBIO_SHOT: "U",
      DARM_KOMPLEX: "U",
      STOFFWECHSEL_SHOT: "U",
      STOFFWECHSEL_KAPSELN: "U",
      HORMON: "U",
      CHOLESTERIN: "U",
      ELEKTROLYTE: "SELF",
      VITAMIN_D3K2: "U",
      OMEGA3: "U",
      MAGNESIUM: "U",
    },
    VITAMIN_D3K2: {
      TROPFEN: "E",
      TROPFEN_MILD: "E",
      KAPSELN: "E",
      TEE: "E",
      SPRAY: "E",
      PROBIO_SHOT: "E",
      DARM_KOMPLEX: "E",
      STOFFWECHSEL_SHOT: "E",
      STOFFWECHSEL_KAPSELN: "E",
      HORMON: "E",
      CHOLESTERIN: "E",
      ELEKTROLYTE: "U",
      VITAMIN_D3K2: "SELF",
      OMEGA3: "E",
      MAGNESIUM: "E",
    },
    OMEGA3: {
      TROPFEN: "E",
      TROPFEN_MILD: "E",
      KAPSELN: "E",
      TEE: "E",
      SPRAY: "E",
      PROBIO_SHOT: "E",
      DARM_KOMPLEX: "E",
      STOFFWECHSEL_SHOT: "E",
      STOFFWECHSEL_KAPSELN: "E",
      HORMON: "E",
      CHOLESTERIN: "E",
      ELEKTROLYTE: "U",
      VITAMIN_D3K2: "E",
      OMEGA3: "SELF",
      MAGNESIUM: "E",
    },
    MAGNESIUM: {
      TROPFEN: "E",
      TROPFEN_MILD: "E",
      KAPSELN: "E",
      TEE: "E",
      SPRAY: "E",
      PROBIO_SHOT: "E",
      DARM_KOMPLEX: "E",
      STOFFWECHSEL_SHOT: "E",
      STOFFWECHSEL_KAPSELN: "E",
      HORMON: "B",
      CHOLESTERIN: "E",
      ELEKTROLYTE: "U",
      VITAMIN_D3K2: "E",
      OMEGA3: "E",
      MAGNESIUM: "SELF",
    },
  };

  const CSAB_NOTES = {
    STOFFWECHSEL_KAPSELN:
      "Enthält Grapefruitextrakt. Nicht geeignet bei Einnahme von Arzneimitteln, die mit Grapefruit wechselwirken (z. B. bestimmte Cholesterin- oder Blutdrucksenker, Immunsuppressiva). Bei Medikamenteneinnahme vorab Rücksprache mit Arzt oder Apotheker halten.",
    GENERIC_B:
      "Diese Kombination ist grundsätzlich möglich, wird aber mit Hinweis geführt. Bei bestehender Medikamenteneinnahme oder Vorerkrankungen sprich vorab kurz mit Arzt, Apotheker oder unserem Kundenservice.",
  };

  // Wird beim ersten connectedCallback aus data-store gesetzt -- Preise
  // selbst kommen bereits in der richtigen Waehrung aus dem Katalog (getrennte
  // Shopify-Stores fuer .com/.ch), hier geht es nur um die Schreibweise.
  let CSAB_STORE = "com";
  function csabMoney(n) {
    if (CSAB_STORE === "ch") return "CHF " + n.toFixed(2);
    return n.toFixed(2).replace(".", ",") + " €";
  }
  function csabPerDay(p) {
    return p.price / p.portions;
  }
  function csabPerDayStr(p) {
    return csabMoney(Math.round(csabPerDay(p) * 100) / 100);
  }
  function csabBundlePricing(a, b, discountPct) {
    const subtotal = a.price + b.price;
    const savings = Math.round(subtotal * (discountPct / 100) * 100) / 100;
    const total = Math.round((subtotal - savings) * 100) / 100;
    const days = Math.min(a.portions, b.portions);
    const perDay = Math.round((total / days) * 100) / 100;
    const perDayUndisc = Math.round((subtotal / days) * 100) / 100;
    return {
      a: a.price,
      b: b.price,
      subtotal,
      savings,
      total,
      days,
      perDay,
      perDayUndisc,
    };
  }

  function csabRawRelation(a, b) {
    return (CSAB_MATRIX[a] || {})[b] || "U";
  }
  function csabRelation(a, b) {
    if (a === b) return "SELF";
    const x = csabRawRelation(a, b),
      y = csabRawRelation(b, a);
    if (x === "NE" || y === "NE") return "NE";
    if (x === "B" || y === "B") return "B";
    if (x === "E" || y === "E") return "E";
    return "U";
  }
  const CSAB_REL_RANK = { E: 0, B: 1, U: 2 };

  function csabThumb(product, size, cls) {
    const px = size || 82;
    const inner = product.image
      ? `<img src="${product.image}" alt="${product.name}" loading="lazy" onerror="this.parentNode.classList.add('is-fallback');this.remove();">`
      : "";
    const fb = `<span class="fb">${csabIcon(product.icon || "leaf", Math.round(px * 0.44))}</span>`;
    return `<div class="csab-thumb ${cls || ""} ${product.image ? "" : "is-fallback"}" style="width:${px}px;height:${px}px;">${inner}${fb}</div>`;
  }

  function csabLog(event, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event }, payload));
    if (typeof window.__csabOnLog === "function")
      window.__csabOnLog(event, payload);
  }

  function csabToast(msg) {
    const t = document.getElementById("csab-toast");
    t.textContent = msg;
    t.classList.add("show");
    clearTimeout(window.__csabToastTimer);
    window.__csabToastTimer = setTimeout(
      () => t.classList.remove("show"),
      2400,
    );
  }

  function csabOpenCartDrawer() {
    const drawer = document.querySelector("cart-drawer#cart-drawer");
    if (drawer && typeof drawer.show === "function") drawer.show();
  }
  async function csabAddToCart(items, cart) {
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:start", { bubbles: true }),
    );
    try {
      const root =
        (window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root) ||
        "/";
      const response = await fetch(`${root}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items, attributes: { "x-sell-ab": true } }),
      });
      const data = await response.json();
      if (!response.ok)
        throw new Error((data && data.description) || "add_to_cart_failed");
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", { bubbles: true }),
      );
      cart.show();
      return data;
    } finally {
      document.documentElement.dispatchEvent(
        new CustomEvent("theme:loading:end", { bubbles: true }),
      );
    }
  }

  class CrossSellAbQuiz extends HTMLElement {
    get cart() {
      return document.querySelector("cart-drawer#cart-drawer") ?? null;
    }
    connectedCallback() {
      if (this.dataset.csabInitialized) return;
      this.dataset.csabInitialized = "";
      CSAB_STORE = this.dataset.store === "ch" ? "ch" : "com";

      const catalogScript = this.querySelector("script[data-csab-catalog]");
      let catalog = [];
      try {
        catalog = catalogScript
          ? JSON.parse(catalogScript.textContent || "[]")
          : [];
      } catch (e) {
        console.error(
          "[cross-sell-ab] Katalog-JSON konnte nicht gelesen werden -- vermutlich fehlt in einem Produkt-Block das Shopify-Produkt oder der Schlüssel.",
          e,
          catalogScript
            ? catalogScript.textContent
            : "(kein <script data-csab-catalog> gefunden)",
        );
        catalog = [];
      }
      this.catalogByKey = Object.fromEntries(
        catalog.map((p) => [
          p.key,
          Object.assign({ icon: CSAB_ICON_BY_KEY[p.key] }, p),
        ]),
      );

      this.currentKey = this.dataset.currentKey;
      this.cur = this.catalogByKey[this.currentKey];
      if (!this.cur) {
        console.warn(
          `[cross-sell-ab] Kein Katalog-Eintrag für den Schlüssel "${this.currentKey}" gefunden. Verfügbare Schlüssel:`,
          Object.keys(this.catalogByKey),
        );
        return;
      }

      this.variant =
        window.CSAB_FORCE_VARIANT || this.dataset.variant || "routine";
      this.schemeId = this.dataset.schemeId || "";
      this.bundleDiscount = parseFloat(this.dataset.bundleDiscount) || 5;
      this.allowUndocumented = this.dataset.allowUndocumented === "true";
      this.showTrust = this.dataset.showTrust === "true";
      this.proof = {
        rating: parseFloat(this.dataset.rating) || 0,
        ratingLabel: this.dataset.ratingLabel || "",
        reviews: this.dataset.reviews || "",
        customers: this.dataset.customers || "",
        shippingFrom: this.dataset.shippingFrom || "",
        returnDays: this.dataset.returnDays || "",
      };
      this.hasProof = !!(
        this.proof.rating &&
        this.proof.reviews &&
        this.proof.customers
      );

      this.reset();
    }

    get isSales() {
      return this.variant === "sales";
    }

    reset() {
      this.state = { step: 0, needKey: null, formatKey: null };
      this.render();
    }

    usable(rel) {
      if (rel === "E" || rel === "B") return true;
      return rel === "U" && this.allowUndocumented;
    }

    availableNeeds() {
      return CSAB_NEEDS.filter((n) =>
        n.candidates.some(
          (c) => c.target !== this.currentKey && this.catalogByKey[c.target],
        ),
      );
    }

    recommend(needKey, formatKey) {
      const need = CSAB_NEED_BY_KEY[needKey];
      if (!need) return null;
      const score = (list) =>
        list
          .filter(
            (c) => c.target !== this.currentKey && this.catalogByKey[c.target],
          )
          .map((c) => ({
            target: c.target,
            reason: c.reason,
            rel: csabRelation(this.currentKey, c.target),
          }))
          .filter((c) => this.usable(c.rel))
          .sort((p, q) => CSAB_REL_RANK[p.rel] - CSAB_REL_RANK[q.rel]);
      const wanted = formatKey
        ? need.candidates.filter((c) => c.formats.includes(formatKey))
        : need.candidates;

      const exact = score(wanted);
      if (exact.length)
        return Object.assign(exact[0], {
          matchLevel: "exact",
          needKey,
          formatKey,
        });

      const inCat = score(need.candidates);
      if (inCat.length) {
        const intended = wanted[0] ? wanted[0].target : null;
        return Object.assign(inCat[0], {
          matchLevel: "category",
          needKey,
          formatKey,
          intended,
        });
      }

      const blocked = need.candidates
        .filter(
          (c) => c.target !== this.currentKey && this.catalogByKey[c.target],
        )
        .map((c) => ({
          target: c.target,
          rel: csabRelation(this.currentKey, c.target),
        }));
      if (!blocked.length) return null;
      const alt =
        CSAB_LAST_RESORT.filter(
          (t) =>
            t !== this.currentKey &&
            this.catalogByKey[t] &&
            !need.candidates.some((c) => c.target === t),
        )
          .map((t) => ({ target: t, rel: csabRelation(this.currentKey, t) }))
          .filter((c) => c.rel === "E")[0] || null;

      return {
        matchLevel: "blocked",
        needKey,
        formatKey,
        blocked,
        alt,
        target: null,
        rel: null,
      };
    }

    bundleRange() {
      const reachable = new Set();
      CSAB_NEEDS.forEach((n) =>
        n.candidates.forEach((c) => reachable.add(c.target)),
      );
      const rows = [...reachable]
        .filter(
          (k) =>
            k !== this.currentKey &&
            this.catalogByKey[k] &&
            this.usable(csabRelation(this.currentKey, k)),
        )
        .map((k) =>
          csabBundlePricing(
            this.cur,
            this.catalogByKey[k],
            this.bundleDiscount,
          ),
        );
      if (!rows.length) return null;
      const perDay = rows.map((r) => r.perDay),
        savings = rows.map((r) => r.savings);
      return {
        count: rows.length,
        minPerDay: Math.min(...perDay),
        maxPerDay: Math.max(...perDay),
        minSave: Math.min(...savings),
        maxSave: Math.max(...savings),
      };
    }

    render() {
      if (this.state.step === 0) return this.renderIntro();
      if (this.state.step === 1) return this.renderNeedStep();
      if (this.state.step === 2) return this.renderFollowUpStep();
      if (this.state.step === 3) return this.renderResult();
    }

    shell(inner, headSub, salesHead) {
      if (this.isSales) {
        return `
          <section class="csab csab--sales">
            <div class="csab-head">
              <div class="hd-icon">${csabIcon("tag", 26)}</div>
              <div class="hd-txt"><h2 class="h5" style="color: #fff;">${(salesHead && salesHead.h) || `Zwei Produkte, ${this.bundleDiscount} % weniger`}</h2><p class="text-sm">${(salesHead && salesHead.p) || headSub}</p></div>
              <div class="csab-savebadge text-sm bold">${this.bundleDiscount} % Rabatt ab 2 Produkten</div>
            </div>
            <div class="csab-stage">${inner}</div>
          </section>`;
      }
      return `
        <section class="csab">
          <div class="csab-head">
            <div class="hd-icon">${csabIcon("sparkle", 26)}</div>
            <div class="hd-txt"><h2 class="h5">Deine Routine, Schritt für Schritt</h2><p class="text-sm">${headSub}</p></div>
            <div class="csab-savebadge text-sm bold">${this.bundleDiscount} % Rabatt ab 2 Produkten</div>
          </div>
          <div class="csab-stage">${inner}</div>
        </section>`;
    }

    proofRow() {
      if (!this.hasProof) return "";
      return `<p class="csab-proof text-sm">${csabStars(this.proof.rating)} <b class="bold">${this.proof.ratingLabel}</b> aus ${this.proof.reviews} Bewertungen <span class="sep">·</span> ${csabIcon("users", 15)} ${this.proof.customers} Kund:innen</p>`;
    }
    trustRow() {
      if (!this.showTrust) return "";
      return `<div class="csab-trust text-x-sm">
        ${this.proof.shippingFrom ? `<span>${csabIcon("truck", 16)} Versandkostenfrei ab ${this.proof.shippingFrom}</span>` : ""}
        ${this.proof.returnDays ? `<span>${csabIcon("shield", 16)} ${this.proof.returnDays} Tage Rückgabe</span>` : ""}
        <span>${csabIcon("check", 16)} Rabatt automatisch im Warenkorb</span>
      </div>`;
    }

    renderIntro() {
      const cur = this.cur;
      const rg = this.bundleRange();
      const abPreis = rg ? csabMoney(rg.minPerDay) : null;
      csabLog("csab_impression", {
        product: this.currentKey,
        variant: this.variant,
        perDayRange: rg ? [rg.minPerDay, rg.maxPerDay] : null,
      });

      if (this.isSales) {
        this.innerHTML = this.shell(
          `
          <div class="csab-intro">
            <div>
              ${this.proofRow()}
              <ul class="csab-sa-benefits">
                <li>${csabIcon("tag", 19)}<span class="text-base"><b class="bold">${this.bundleDiscount} % sparen</b> – automatisch, sobald ein zweites Produkt im Warenkorb liegt.</span></li>
                <li>${csabIcon("check", 19)}<span class="text-base"><b class="bold">Auf Dich abgestimmt</b> – geprüfte Kombination, passend zu ${cur.short} und Deinem Ziel.</span></li>
                <li>${csabIcon("clock", 19)}<span class="text-base"><b class="bold">In 20 Sekunden</b> – zwei Fragen, eine persönliche Empfehlung.</span></li>
              </ul>
              <button class="button button--primary csab-cta csab-block" data-csab="start">${csabIcon("cart", 20)} Bundle finden &amp; ${this.bundleDiscount} % sparen</button>
              ${this.trustRow()}
            </div>
            ${
              rg
                ? `
            <div class="csab-sa-anchor">
              <div class="kicker smallcaps">Deine Kombination ab</div>
              <div class="amount h1">${abPreis} <small class="text-sm">/ Tag</small></div>
              <div class="compare text-sm">für beide Produkte zusammen<br>${cur.short} allein: ${csabPerDayStr(cur)} / Tag</div>
              <div class="savepill text-sm bold">In jedem Fall ${this.bundleDiscount} % Rabatt</div>
            </div>`
                : `
            <div class="csab-sa-anchor">
              <div class="kicker smallcaps">Dein Vorteil</div>
              <div class="amount h1">${this.bundleDiscount} %</div>
              <div class="compare text-sm">Rabatt auf die gesamte Bestellung, ab 2 Produkten</div>
            </div>`
            }
          </div>
        `,
          "",
          {
            h: rg
              ? `Zwei Produkte ab ${csabMoney(rg.minPerDay)} pro Tag`
              : `Zwei Produkte, ${this.bundleDiscount} % weniger`,
            p: `Stell Dir in 20 Sekunden die passende Kombination zu ${cur.name} zusammen – der Mengenrabatt läuft automatisch mit.`,
          },
        );
        const startBtn = this.querySelector('[data-csab="start"]');
        if (startBtn)
          startBtn.onclick = () => {
            csabLog("csab_started", {
              product: this.currentKey,
              variant: this.variant,
            });
            this.state.step = 1;
            this.render();
          };
        return;
      }

      this.innerHTML = this.shell(
        `
        <div class="csab-intro">
          <div>
            <p class="csab-lead text-base">Der Unterschied kommt selten von einem einzelnen Produkt. Er kommt davon, dranzubleiben. Die passende Ergänzung zu Deine/n <strong class="bold" style="color: #3b5600">${cur.name}</strong> ist deshalb mehr als ein Zusatzkauf – sie ist der Schritt, mit dem aus einem guten Vorsatz eine Routine wird, die Du in drei Monaten noch hast.</p>
            <ul class="csab-steps">
              <li><span class="num text-x-sm bold">1</span><span class="text-sm">Zwei kurze Fragen dazu, woran Du langfristig arbeiten möchtest.</span></li>
              <li><span class="num text-x-sm bold">2</span><span class="text-sm">Eine Empfehlung, die zu Deine/n ${cur.short} passt <em>und</em> sich in Deinen Alltag einfügt – nicht umgekehrt.</span></li>
            </ul>
            <button class="button button--primary csab-cta" data-csab="start">Meine Routine zusammenstellen ${csabIcon("arrowRight", 19)}</button>
            <div class="csab-timehint text-x-sm">Unter 30 Sekunden · keine Anmeldung nötig</div>
          </div>
          ${
            rg
              ? `
          <div class="csab-savecard">
            <div class="lbl smallcaps">Deine Routine ab</div>
            <div class="big h1">${abPreis} <small class="text-sm">pro Tag</small></div>
            <p class="text-sm">Für beide Produkte zusammen – ${cur.short} allein kosten dich ${csabPerDayStr(cur)} am Tag. Der Mengenrabatt von ${this.bundleDiscount} % ab zwei Produkten ist schon eingerechnet.</p>
          </div>`
              : `
          <div class="csab-savecard">
            <div class="lbl smallcaps">Dein Vorteil</div>
            <div class="big h1">${this.bundleDiscount} % <small class="text-sm">ab 2 Produkten</small></div>
            <p class="text-sm">Sobald zwei Produkte im Warenkorb liegen, ziehen wir ${this.bundleDiscount} % von Deiner Bestellung ab – ganz automatisch.</p>
          </div>`
          }
        </div>
      `,
        `Abgestimmt auf ${cur.name} und auf das, was Du Dir vorgenommen hast.`,
      );

      const startBtn = this.querySelector('[data-csab="start"]');
      if (startBtn)
        startBtn.onclick = () => {
          csabLog("csab_started", { product: this.currentKey });
          this.state.step = 1;
          this.render();
        };
    }

    quizStage(stepNum, stepLabel, question, crumbHtml, optionsHtml, navHtml) {
      const pct = Math.round((stepNum / 3) * 100);
      return `
        <div class="csab-progress"><div style="width:${pct}%"></div></div>
        <div class="csab-quizhead">
          <div class="csab-step-label smallcaps">${stepLabel}</div>
          <div class="csab-savenudge text-x-sm bold">${csabIcon("check", 15)} ${this.bundleDiscount} % Rabatt, sobald 2 Produkte im Warenkorb sind</div>
        </div>
        <h3 class="csab-question h4">${question}</h3>
        ${crumbHtml || '<div style="height:14px"></div>'}
        <div class="csab-options">${optionsHtml}</div>
        ${navHtml || ""}`;
    }
    optionBtn(attr, val, icon, label, sub) {
      return `<button class="csab-option" ${attr}="${val}">
          <span class="opt-ico">${csabIcon(icon, 21)}</span>
          <span class="bold">${label}${sub ? `<span class="opt-sub text-sm">${sub}</span>` : ""}</span>
        </button>`;
    }
    backBtn() {
      return `<div class="csab-navrow"><button class="csab-textbtn text-sm" data-csab="back">${csabIcon("arrowLeft", 16)} Zurück</button></div>`;
    }

    renderNeedStep() {
      const opts = this.availableNeeds()
        .map((o) => this.optionBtn("data-key", o.key, o.icon, o.label, o.sub))
        .join("");
      this.innerHTML = this.shell(
        this.quizStage(
          1,
          "Frage 1 von 2",
          "Woran möchtest Du langfristig arbeiten?",
          "",
          opts,
          this.backBtn(),
        ),
        "Schritt 1 – Dein Ziel",
      );
      this.querySelectorAll(".csab-option").forEach((btn) => {
        btn.onclick = () => {
          this.state.needKey = btn.dataset.key;
          csabLog("csab_question_answered", {
            step: 1,
            question: "need",
            answer: this.state.needKey,
            variant: this.variant,
          });
          this.state.step = 2;
          this.render();
        };
      });
      const back = this.querySelector('[data-csab="back"]');
      if (back)
        back.onclick = () => {
          this.state.step = 0;
          this.render();
        };
    }

    renderFollowUpStep() {
      const need = CSAB_NEED_BY_KEY[this.state.needKey];
      const opts = need.followUp.options
        .map((o) => this.optionBtn("data-fmt", o.key, o.icon, o.label, o.sub))
        .join("");
      const crumb = `<p class="csab-crumb text-sm">${csabIcon(need.icon, 16)} Dein Ziel: <b class="bold">${need.label}</b></p>`;
      this.innerHTML = this.shell(
        this.quizStage(
          2,
          "Frage 2 von 2",
          need.followUp.question,
          crumb,
          opts,
          this.backBtn(),
        ),
        "Schritt 2 – damit es in Deinen Alltag passt",
      );
      this.querySelectorAll(".csab-option").forEach((btn) => {
        btn.onclick = () => {
          this.state.formatKey = btn.dataset.fmt;
          csabLog("csab_question_answered", {
            step: 2,
            question: "followup",
            need: this.state.needKey,
            answer: this.state.formatKey,
            variant: this.variant,
          });
          this.state.step = 3;
          this.render();
        };
      });
      const back = this.querySelector('[data-csab="back"]');
      if (back)
        back.onclick = () => {
          this.state.step = 1;
          this.render();
        };
    }

    renderResult() {
      const cur = this.cur;
      const need = CSAB_NEED_BY_KEY[this.state.needKey];
      const fmtOpt = need.followUp.options.find(
        (o) => o.key === this.state.formatKey,
      );
      const rec = this.recommend(this.state.needKey, this.state.formatKey);

      if (!rec) {
        this.innerHTML = this.shell(
          `
          <p class="csab-fallback text-base">Zu dieser Kombination können wir Dir aktuell keine Empfehlung aussprechen. Schreib uns kurz – unser Kundenservice stellt Dir gerne persönlich eine Routine zusammen. Der Rabatt von ${this.bundleDiscount} % ab zwei Produkten gilt selbstverständlich trotzdem.</p>
          <div class="csab-navrow"><button class="csab-textbtn text-sm" data-csab="restart">${csabIcon("refresh", 16)} Nochmal starten</button></div>
        `,
          "Kein Ergebnis",
        );
        const r = this.querySelector('[data-csab="restart"]');
        if (r) r.onclick = () => this.reset();
        return;
      }

      if (rec.matchLevel === "blocked") {
        const namen = rec.blocked.map((b) => this.catalogByKey[b.target].name);
        const liste =
          namen.length > 1
            ? namen.slice(0, -1).join(", ") + " und " + namen[namen.length - 1]
            : namen[0] || "";
        csabLog("csab_blocked", {
          current: this.currentKey,
          need: this.state.needKey,
          followup: this.state.formatKey,
          blocked: rec.blocked.map((b) => b.target),
          variant: this.variant,
        });

        this.innerHTML = this.shell(
          `
          <div style="max-width:640px;">
            <span class="csab-badge warn text-x-sm bold">${csabIcon("alert", 14)} Diese Kombination empfehlen wir nicht</span>
            <h3 class="csab-question h4" style="margin-top:4px;">Zu ${cur.name} passt hier gerade nichts</h3>
            <p class="csab-lead text-base" style="margin-bottom:18px;">Im Bereich „${need.label}" käme ${liste} in Frage – aber genau diese Kombination mit ${cur.name} ist bei uns ausgeschlossen. Statt Dir ersatzweise etwas anzubieten, das Dein Ziel gar nicht adressiert, sagen wir es Dir lieber direkt.</p>
            <p class="csab-lead text-base" style="margin-bottom:22px;">Wenn Dir dieses Ziel wichtig ist, sprich uns gerne an – oder wähle ein anderes Ziel, für das wir Dir eine saubere Empfehlung geben können.</p>
            <button class="button button--primary csab-cta" data-csab="otherGoal">Anderes Ziel wählen ${csabIcon("arrowRight", 19)}</button>
            ${
              rec.alt
                ? `
            <div class="csab-secondary" style="margin-top:26px;">
              ${csabThumb(this.catalogByKey[rec.alt.target], 46)}
              <div>
                <div class="lbl smallcaps">Unabhängig davon eine gute Basis</div>
                <div class="name text-sm" style="font-weight: 700;">${this.catalogByKey[rec.alt.target].name} · ${csabPerDayStr(this.catalogByKey[rec.alt.target])} / Tag</div>
              </div>
            </div>`
                : ""
            }
          </div>
        `,
          "Kein passendes Produkt in dieser Kategorie",
        );
        const og = this.querySelector('[data-csab="otherGoal"]');
        if (og)
          og.onclick = () => {
            this.state.step = 1;
            this.state.formatKey = null;
            this.render();
          };
        return;
      }

      const product = this.catalogByKey[rec.target];
      const pr = csabBundlePricing(cur, product, this.bundleDiscount);

      const badge =
        rec.rel === "E"
          ? `<span class="csab-badge ok text-x-sm bold">${csabIcon("check", 14)} Empfohlene Kombination</span>`
          : rec.rel === "B"
            ? `<span class="csab-badge warn text-x-sm bold">${csabIcon("alert", 14)} Bedingt empfohlen – bitte Hinweis beachten</span>`
            : `<span class="csab-badge neutral text-x-sm bold">${csabIcon("leaf", 14)} Passende Ergänzung</span>`;

      let swapHtml = "";
      if (
        rec.matchLevel === "category" &&
        rec.intended &&
        this.catalogByKey[rec.intended]
      ) {
        swapHtml = `<div class="csab-swap text-sm">${csabIcon("info", 17)}<span><strong class="bold">Kleine Abweichung von Deiner Auswahl:</strong> ${this.catalogByKey[rec.intended].name} empfehlen wir zusammen mit ${cur.name} nicht. Innerhalb von „${need.label}" passt ${product.name} am besten zu Dir.</span></div>`;
      }

      const note =
        rec.rel === "B"
          ? CSAB_NOTES[rec.target] || CSAB_NOTES.GENERIC_B
          : CSAB_NOTES[rec.target] || null;

      csabLog("csab_recommendation_shown", {
        current: this.currentKey,
        target: rec.target,
        relation: rec.rel,
        matchLevel: rec.matchLevel,
        variant: this.variant,
        need: this.state.needKey,
        followup: this.state.formatKey,
        bundleValue: pr.total,
        savings: pr.savings,
        perDay: pr.perDay,
      });

      if (this.isSales) {
        this.innerHTML = this.shell(
          `
          <div class="csab-sa-resultgrid">
            <div class="csab-sa-offer">
              <div class="ribbon text-x-sm bold">${csabIcon("tag", 15)} Bundle-Preis · ${this.bundleDiscount} % gespart</div>
              <div class="perday h1">${csabMoney(pr.perDay)} <small class="text-sm">/ Tag</small></div>
              <div class="sub text-sm"><span class="was">${csabMoney(pr.perDayUndisc)}</span> ohne Rabatt · reicht für ${pr.days} Tage</div>
              <div class="csab-sa-rows">
                <div class="r text-sm"><span>${cur.short}</span><span>${csabMoney(pr.a)}</span></div>
                <div class="r text-sm"><span>${product.short}</span><span>${csabMoney(pr.b)}</span></div>
                <div class="r save text-sm" style="font-weight: 700;"><span>Mengenrabatt ${this.bundleDiscount} %</span><span>−${csabMoney(pr.savings)}</span></div>
                <div class="r tot text-base bold"><span>Gesamt</span><span>${csabMoney(pr.total)}</span></div>
              </div>
              <button class="button button--primary csab-cta csab-block" data-csab="addBundle">${csabIcon("cart", 20)} Bundle sichern – ${csabMoney(pr.total)}</button>
              <button class="button button--secondary csab-block" data-csab="addSingle">Nur ${cur.short} für ${csabMoney(pr.a)}</button>
              <p class="legal">Rabatt wird automatisch im Warenkorb abgezogen, sobald mindestens zwei Produkte enthalten sind. Tagespreis = Packungspreis ÷ Tagesportionen. Alle Preise inkl. MwSt., zzgl. Versand.</p>
            </div>

            <div>
              ${badge}
              <div class="csab-sa-pick">
                ${csabThumb(product, 82)}
                <div>
                  <div class="cat smallcaps">${product.category}</div>
                  <h3 class="h5">${product.name}</h3>
                  <p class="why text-sm">${rec.reason}</p>
                </div>
              </div>
              ${swapHtml}
              ${note ? `<div class="csab-note text-sm">${csabIcon("alert", 17)}<span><strong class="bold">Wichtiger Hinweis:</strong> ${note}</span></div>` : ""}
              ${this.proofRow() ? `<div style="margin-top:18px;">${this.proofRow()}</div>` : ""}
              ${this.trustRow()}
              <div class="csab-feedback text-sm">
                Passt das?
                <button data-csab="up" aria-label="Ja">${csabIcon("thumbUp", 17)}</button>
                <button data-csab="down" aria-label="Nein">${csabIcon("thumbDown", 17)}</button>
                <button class="csab-textbtn text-sm" data-csab="restart" style="margin-left:6px;">${csabIcon("refresh", 15)} Andere Empfehlung</button>
              </div>
            </div>
          </div>
        `,
          "",
          {
            h: `Dein Bundle: ${csabMoney(pr.total)} statt ${csabMoney(pr.subtotal)}`,
            p: `${cur.short} + ${product.short} – Du sparst ${csabMoney(pr.savings)}.`,
          },
        );

        this.bindResultActions(rec, product, pr);
        return;
      }

      this.innerHTML = this.shell(
        `
        <div class="csab-resultgrid">
          <div>
            ${badge}
            <div class="csab-product">
              ${csabThumb(product, 82)}
              <div>
                <div class="cat smallcaps">${product.category}</div>
                <h3 class="h5">${product.name}</h3>
                <p class="why text-sm">${rec.reason}</p>
              </div>
            </div>
            <div class="csab-routine text-sm">${csabIcon("clock", 18)}<span>Zusammen reichen beide Produkte <strong class="bold">${pr.days} Tage</strong>. Das ist ungefähr die Zeit, die es braucht, bis eine Einnahme kein Vorsatz mehr ist, sondern einfach dazugehört.</span></div>
            ${swapHtml}
            ${note ? `<div class="csab-note text-sm">${csabIcon("alert", 17)}<span><strong class="bold">Wichtiger Hinweis:</strong> ${note}</span></div>` : ""}
            <div class="csab-secondary">
              <div class="mini">${csabIcon(need.icon, 20)}</div>
              <div>
                <div class="lbl smallcaps">Deine Angaben</div>
                <div class="name text-sm bold" style="font-weight: 700;">${need.label} · ${fmtOpt ? fmtOpt.label : "–"}</div>
              </div>
            </div>
            <div class="csab-feedback text-sm">
              Passt diese Empfehlung zu Dir?
              <button data-csab="up" aria-label="Ja">${csabIcon("thumbUp", 17)}</button>
              <button data-csab="down" aria-label="Nein">${csabIcon("thumbDown", 17)}</button>
              <button class="csab-textbtn text-sm" data-csab="restart" style="margin-left:6px;">${csabIcon("refresh", 15)} Andere Empfehlung</button>
            </div>
          </div>

          <div class="csab-bundle">
            <p class="bundle-title text-sm bold">Deine Routine <span class="pct text-x-sm bold">−${this.bundleDiscount} %</span></p>
            <div class="bundle-hero">
              <div class="amount h1">${csabMoney(pr.perDay)} <small class="text-sm">/ Tag</small></div>
              <div class="cap text-sm">für beide Produkte zusammen, <span class="was">${csabMoney(pr.perDayUndisc)}</span> ohne Rabatt<br>reicht für ${pr.days} Tage</div>
            </div>
            <div class="bundle-line text-x-sm"><span class="nm">${cur.name}<em style="font-size: 11px;">${csabPerDayStr(cur)} / Tag · ${cur.portions} Portionen</em></span><span class="text-x-sm">${csabMoney(pr.a)}</span></div>
            <div class="bundle-line text-x-sm"><span class="nm">${product.name}<em style="font-size: 11px;">${csabPerDayStr(product)} / Tag · ${product.portions} Portionen</em></span><span class="text-x-sm">${csabMoney(pr.b)}</span></div>
            <div class="bundle-line save text-x-sm"><span class="nm">Mengenrabatt ab 2 Produkten</span><span >−${csabMoney(pr.savings)}</span></div>
            <div class="bundle-line total text-base bold"><span class="nm">Gesamt</span><span><span class="strike">${csabMoney(pr.subtotal)}</span>${csabMoney(pr.total)}</span></div>
            <button class="button button--primary csab-block csab-bundlebtn" data-csab="addBundle">
              <div>Routine starten – ${csabMoney(pr.perDay)} / Tag</div>
              <div class="sub text-x-sm">${csabMoney(pr.total)} gesamt · Du sparst ${csabMoney(pr.savings)}</div>
            </button>
            <button class="button button--secondary csab-block" data-csab="addSingle" style="margin-top:10px;">Nur ${cur.short} – ${csabPerDayStr(cur)} / Tag (${csabMoney(pr.a)})</button>
            <p class="csab-legal text-x-sm">Tagespreis = Packungspreis ÷ Tagesportionen laut Verzehrempfehlung. Der Rabatt wird automatisch im Warenkorb abgezogen, sobald mindestens zwei Produkte enthalten sind. Alle Preise inkl. MwSt., zzgl. Versand.</p>
          </div>
        </div>
      `,
        "Dein Ergebnis",
      );

      this.bindResultActions(rec, product, pr);
    }

    bindResultActions(rec, product, pr) {
      const cur = this.cur;
      const addBundleBtn = this.querySelector('[data-csab="addBundle"]');
      if (addBundleBtn)
        addBundleBtn.onclick = async () => {
          addBundleBtn.disabled = true;
          try {
            await csabAddToCart(
              [
                {
                  id: cur.variantId,
                  quantity: 1,
                  properties: { _is_bundle: true },
                },
                {
                  id: product.variantId,
                  quantity: 1,
                  properties: { _is_bundle: true },
                },
              ],
              this.cart,
            );
            csabLog("csab_add_to_cart", {
              type: "bundle",
              variant: this.variant,
              items: [this.currentKey, rec.target],
              value: pr.total,
              discount: pr.savings,
            });
          } catch (e) {
            csabToast("Fehler beim Hinzufügen zum Warenkorb.");
          } finally {
            addBundleBtn.disabled = false;
          }
        };

      const addSingleBtn = this.querySelector('[data-csab="addSingle"]');
      if (addSingleBtn)
        addSingleBtn.onclick = async () => {
          addSingleBtn.disabled = true;
          try {
            await csabAddToCart(
              [{ id: cur.variantId, quantity: 1 }],
              this.cart,
            );
            csabLog("csab_add_to_cart", {
              type: "single",
              variant: this.variant,
              items: [this.currentKey],
              value: pr.a,
              discount: 0,
            });
            csabToast(`${cur.name} hinzugefügt`);
            csabOpenCartDrawer();
          } catch (e) {
            csabToast("Fehler beim Hinzufügen zum Warenkorb.");
          } finally {
            addSingleBtn.disabled = false;
          }
        };

      const up = this.querySelector('[data-csab="up"]');
      if (up)
        up.onclick = () =>
          csabLog("csab_feedback", {
            helpful: true,
            variant: this.variant,
            target: rec.target,
          });
      const down = this.querySelector('[data-csab="down"]');
      if (down)
        down.onclick = () =>
          csabLog("csab_feedback", {
            helpful: false,
            variant: this.variant,
            target: rec.target,
          });
      const restart = this.querySelector('[data-csab="restart"]');
      if (restart) restart.onclick = () => this.reset();
    }
  }

  customElements.define("cross-sell-ab-quiz", CrossSellAbQuiz);
}
